import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { selectMaintenanceGuides } from '../../store/selectors/faqsNotesDocuments';
import  MaintenanceGuides from '../../components/MaintenanceGuides';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments,updateFaqsNotesDocuments,deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch,clearSearch } from '../../store/actions/search';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';

class ItemMaintenanceGuide extends Component {
  constructor(props) {
    super(props);
  }

  state = {
   loading:true
  };

  componentDidMount() {
    this.props.clearSearch()

    // Modified by: Tarkeshwar Prasad Yadav
    // Modified on: 23/08/2022
    // Jira ticket: JUN-3051
    // Comment: Added setTimeout to give enough time to filter data and to set all the relevant data to show.
    setTimeout(()=>this.setState({loading:false}),3000)
  }

  onSaveMaintenanceGuide = maintenanceguide => {
    const {  onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments, user  } = this.props;
    let utcTime = ''
    let defaultDate= new Date();
    if(maintenanceguide.appointment){

   
    let date = new Date(maintenanceguide.appointment.date);
    let time = new Date(maintenanceguide.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)
    // utcTime = date.toUTCString()
      utcTime = date
  }

    if(maintenanceguide.id){
      let data = {
        "id": maintenanceguide.id,
        ItemId: this.props.item.id,
        Name: 'MAINTENANCEGUIDE',
        Type: 'MAINTENANCEGUIDE',
        "data": JSON.stringify(maintenanceguide).toString(),
        "UserId": user.id,
        MaintenanceReminderFrom:'Catalog',
        IsSuiteWarrantyStartDate:maintenanceguide?.IsSuiteWarrantyStartDate,
        Time:maintenanceguide?.appointment?.time
      }
      if(maintenanceguide.appointment){
        data = {...data, ReminderDate: maintenanceguide?.IsSuiteWarrantyStartDate === false ? utcTime :defaultDate, 
          repeatType: maintenanceguide.repeatType ? maintenanceguide.repeatType : '',
          toggle: maintenanceguide.toggle};
          if(maintenanceguide.repeatType === 'Custom') {
            data = {...data, repeatEvery: Number(maintenanceguide.repeatEvery), repeatTypeEvery: maintenanceguide.repeatTypeEvery}
          }
      }
      onUpdateFaqsNotesDocuments(data)

    }else{
      maintenanceguide = { ...maintenanceguide,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}
      let data = {
        ItemId: this.props.item.id,
        Name: ' MAINTENANCEGUIDE',
        Type: 'MAINTENANCEGUIDE',
        Data: JSON.stringify(maintenanceguide).toString(),
        UserId: user.id,
        MaintenanceReminderFrom:'Catalog',
        IsSuiteWarrantyStartDate:maintenanceguide?.IsSuiteWarrantyStartDate,
        Time:maintenanceguide?.appointment?.time
      }
      if(maintenanceguide.appointment){
        data = {...data, ReminderDate: maintenanceguide?.IsSuiteWarrantyStartDate === false ? utcTime :defaultDate, 
          repeatType: maintenanceguide.repeatType ? maintenanceguide.repeatType : '', 
          toggle: maintenanceguide.toggle};
          if(maintenanceguide.repeatType === 'Custom') {
            data = {...data, repeatEvery: Number(maintenanceguide.repeatEvery), repeatTypeEvery: maintenanceguide.repeatTypeEvery}
          }
      }
      
    onSaveFaqsNotesDocuments(data)
    }
  }

  render() {
    const { maintenanceguides, item,onDeleteFaqsNotesDocuments,setSearch,user, loader } = this.props;
    return (
      this.state.loading ? <Loader /> :
      <MaintenanceGuides
        from = "Catalog"
        onlyView={user.roles[0].role.name === 'Strata Manager' ? true : false}
        breadcrumb={item.name}
        maintenanceguides={maintenanceguides}
        onSaveMaintenanceGuide={this.onSaveMaintenanceGuide}
        onDeleteNote={  maintenanceguides => onDeleteFaqsNotesDocuments({...maintenanceguides,Type:'MAINTENANCEGUIDE'})}
        onSearch={e => setSearch({  maintenanceguide: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  maintenanceguides: selectMaintenanceGuides(state),
  user: selectAuthenticatedUser(state),
  loader:selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocumentss: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemMaintenanceGuide);
